import html2pdf from "html2pdf.js";
import Cookie from "js-cookie";
import moment from "moment";
import instance from "../../util/axios";
import axiosAws from "axios";
function formatDate(date) {
  if (date !== undefined && date !== "") {
    const myDate = new Date(date);
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ][myDate.getMonth()];
    return `${myDate.getDate()} ${month} ${myDate.getFullYear()}`;
  }
  return "";
}


async function generatePdfBlob(element, user_id, fileName) {
  if (!element) throw new Error("PDF content not found!");

  const previousDisplay = element.style.display;
  element.style.display = "block";

  const pdfBlob = await html2pdf()
    .from(element)
    .set({
      margin: 0,
      filename: fileName || `user-${user_id}-Medical-Consent.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { dpi: 192, scale: 3, letterRendering: true, useCORS: true },
      jsPDF: { unit: "cm", format: "a4", orientation: "p" },
    })
    .outputPdf("blob");

  element.style.display = previousDisplay;

  return pdfBlob;
}


async function getPresignedUrl(user_id, contentType) {
  const NewDate = moment(new Date(), "DD-MM-YYYY");
  const form_data = new FormData();
  form_data.append("content_type", contentType);
  form_data.append(
    "file_name",
    `Medical_Consent_History_${user_id}_${formatDate(NewDate)}.pdf`
  );

  const { data } = await instance.post("/admin/v1/images/s3", form_data, {
    headers: {
      Authorization: "Bearer " + Cookie.get("access_token_clinic"),
    },
  });

  return data;
}

async function uploadToS3(url, file, contentType) {
  const res = await axiosAws.put(url, file, {
    headers: {
      "x-amz-acl": "public-read-write",
      "Content-Type": contentType,
    },
  });
  return res;
}

async function storepdf({ user_id, clinic_id, pdf_url }) {
  try {
    await instance.post(
      "/admin/v1/provider/user-medical-consent-history",
      {
        user_id,
        clinic_id,
        pdf_url,
      },
      {
        headers: {
          Authorization: "Bearer " + Cookie.get("access_token_clinic"),
        },
      }
    );
  } catch (e) {
  }
}
export async function downloadPdf({
  user_id,
  clinic_id,
  fileName = null,
  element,
  files = [],
}) {
  try {
    let pdfBlob;

    const pdfFile = files.find((file) => file.type === "application/pdf");
    if (pdfFile) {
      pdfBlob = pdfFile;
    } else {
      pdfBlob = await generatePdfBlob(element, user_id, fileName);
    }
    const presignedData = await getPresignedUrl(user_id, pdfBlob.type);

    await uploadToS3(presignedData.url, pdfBlob, pdfBlob.type);
    

    await storepdf({
      user_id,
      clinic_id,
      pdf_url : presignedData.key,
    });

    return pdfBlob;
  } catch (error) {
    console.error("PDF Download/Upload Error:", error);
  }
}